import { useState } from 'react';

export const TOP_FILTERS = ['family-friendly', 'instantconfirmation'];

function useTopFilters(initialSelectedFilters) {
  const topFilters = initialSelectedFilters.filter((filter) =>
    TOP_FILTERS.includes(filter.uid),
  );
  const topFilterValues = topFilters.map(({ uid }) => uid) || [];
  const [topFilterOptions, setTopFilterOptions] =
    useState<string[]>(topFilterValues);

  const onToggleTopFilter = (value: string) => {
    const isSelected = topFilterOptions.some((item) => item === value);
    if (isSelected) {
      setTopFilterOptions(
        (prevDuration) => prevDuration.filter((item) => item !== value) || [],
      );
    } else {
      setTopFilterOptions((prevDuration) => [...prevDuration, value]);
    }
  };

  return {
    topFilterOptions,
    onToggleTopFilter,
  };
}

export default useTopFilters;
